import React, { Component } from 'react';
import { getFolders, getFolderPresentation } from '../../actions';
import classNames from 'classnames';
import PropTypes from 'prop-types'

class SelectFieldQuiz extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      folders: [],
      presentations: [],
    }
  }
  
  
  async componentDidMount() {
    try {
      let folders = await getFolders();
      this.setState({
        folders: folders,
        presentations: [],
      });
    } catch (error) {
      
    }
  }


  onChangeFolder = async(e) => {
    const {input} = this.props;
    
    input.onChange(null);
    
    let presentations = await getFolderPresentation(e.target.value);
    this.setState({
      presentations: presentations,
    })
  }

  render() {
    const {input, type, disabled, meta: { touched, error }, placeholder, label, } = this.props;
    const { presentations, folders } = this.state;
    const {formatMessage} = this.context;
    return (
      <div>
        <div className={classNames("create-dialog-form__group create-dialog-form__group--indent-bottom", {disabled})}>
          <label>{formatMessage('labelInputFolder')}</label>
            <select onChange={this.onChangeFolder} disabled={disabled} className="create-dialog-form__control" >
              <option value={0}></option>
              {folders.map(option => <option key={'folder-' + option.id} value={option.id}>{option.title}</option>)}
            </select>
        </div>
        <div className={classNames("create-dialog-form__group create-dialog-form__group--indent-bottom", {disabled})}>
           <label>{formatMessage('labelInputPresentation')}</label>
            <select {...input} disabled={disabled} className="create-dialog-form__control" >
              <option></option>
              {presentations.map(option => <option key={'present-' + option.id} value={option.id}>{option.name}</option>)}
            </select>
          {touched && ((error && <span style={{color: 'red'}}>{error}</span>))}
        </div>
      </div>
    );
  }
}

export default SelectFieldQuiz;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmPresentation/components/FormContent/SelectField.js